import { useAuth } from "@/contexts/AuthContext";
import GoogleSignInButton from "@/components/auth/GoogleSignInButton";
import SimplePage from "@/components/structure/SimplePage";

export default function AuthTest() {
  const { user, isAuthenticated, logout, loading, oauthConfig, doTokenRefresh } = useAuth();

  if (loading) {
    return (
      <SimplePage title="Authentication Test">
        <p>Loading...</p>
      </SimplePage>
    );
  }

  return (
    <SimplePage title="Authentication Test">
      <div className="max-w-2xl mx-auto">
        <div className="bg-white p-6 rounded-lg shadow mb-6">
          <h2 className="text-lg font-semibold mb-4">OAuth Configuration</h2>
          <pre className="bg-gray-100 p-3 rounded text-sm overflow-auto">
            {JSON.stringify(oauthConfig, null, 2)}
          </pre>
        </div>

        <div className="bg-white p-6 rounded-lg shadow mb-6">
          <h2 className="text-lg font-semibold mb-4">Authentication Status</h2>
          <p>
            <strong>Authenticated:</strong> {isAuthenticated ? "Yes" : "No"}
          </p>
          <p>
            <strong>Loading:</strong> {loading ? "Yes" : "No"}
          </p>
        </div>

        {isAuthenticated ? (
          <div className="bg-white p-6 rounded-lg shadow mb-6">
            <h2 className="text-lg font-semibold mb-4">User Information</h2>
            <pre className="bg-gray-100 p-3 rounded text-sm overflow-auto mb-4">
              {JSON.stringify(user, null, 2)}
            </pre>
            <button
              onClick={logout}
              className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
            >
              Sign Out
            </button>
          </div>
        ) : (
          <div className="bg-white p-6 rounded-lg shadow">
            <h2 className="text-lg font-semibold mb-4">Sign In</h2>
            <GoogleSignInButton />
          </div>
        )}

        <div className="bg-white p-6 rounded-lg shadow">
          <h2 className="text-lg font-semibold mb-4">Token Information</h2>
          <p>
            <strong>Access Token:</strong>{" "}
            {localStorage.getItem("access_token") || "Not present"}
          </p>
          <p>
            <strong>Refresh Token:</strong>{" "}
            {localStorage.getItem("refresh_token") || "Not present"}
          </p>

          <p>
            <strong>Manually Refresh Token:</strong>
            <button
              onClick={async () => {
                const refreshToken = localStorage.getItem("refresh_token");
                if (refreshToken) {
                  try {
                    await doTokenRefresh(refreshToken);
                    // trigger page reload to reflect new tokens
                    window.location.reload();
                    // Optionally, show a success message
                    alert("Tokens refreshed successfully!");
                  } catch (error) {
                    console.error("Failed to refresh token:", error);
                    alert("Failed to refresh token. Check console for details.");
                  }
                } else {
                  alert("No refresh token available.");
                }
              }}
              className="ml-2 bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
            >
              Refresh Token
            </button>
          </p>

          {localStorage.getItem("access_token") && (
            <button
              onClick={() => {
                localStorage.removeItem("access_token");
                localStorage.removeItem("refresh_token");
                window.location.reload();
              }}
              className="mt-2 bg-yellow-500 text-white px-4 py-2 rounded hover:bg-yellow-600"
            >
              Clear Local Tokens
            </button>
          )}
        </div>
      </div>
    </SimplePage>
  );
}
